import { Table } from 'react-bootstrap'
import { FaCheckCircle, FaTimes } from 'react-icons/fa'
import styles from '~/styles/_pricing.module.scss'

type FeatureCell = { feature: string; free: boolean; premium: boolean }

const FEATURE_TABLE: FeatureCell[] = [
  { feature: '記事の作成', free: true, premium: true },
  { feature: '本の作成', free: true, premium: true },
  { feature: 'LaTeXエクスポート', free: false, premium: true },
  { feature: '共同編集', free: false, premium: true },
  { feature: '公開範囲の設定', free: false, premium: true },
  { feature: '広告の非表示', free: false, premium: true },
]

export const PlanComparisonSection = () => (
  <section key="comparing" className="bg-white py-7">
    <h2 className={styles.h2}>機能比較</h2>
    <Table
      className="mx-auto mb-7"
      style={{ maxWidth: 840 }}
      striped
      bordered={false}
    >
      <thead>
        <tr>
          <th></th>
          <th className="text-center">
            無料
            <br className="d-sm-none" />
            プラン
          </th>
          <th className="text-center">
            プレミアム
            <br className="d-sm-none" />
            プラン
          </th>
        </tr>
      </thead>
      <tbody>
        {FEATURE_TABLE.map((feature_detail) => (
          <tr key={feature_detail.feature}>
            <td className="fw-bold ps-6 ps-sm-7">{feature_detail.feature}</td>
            <td className="text-center">
              {feature_detail.free ? (
                <FaCheckCircle style={{ color: '#2c90d3' }} />
              ) : (
                <FaTimes style={{ color: '#a8aeb4' }} />
              )}
            </td>
            <td className="text-center">
              {feature_detail.premium ? (
                <FaCheckCircle style={{ color: '#2c90d3' }} />
              ) : (
                <FaTimes style={{ color: '#a8aeb4' }} />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
    <div className="text-center text-primary mb-2">And more...</div>
    <div className="text-center fw-bold">
      その他にも、便利な機能が続々追加予定！
    </div>
  </section>
)
